import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

export const advP1FloorBudget: FaireAdvertiserProfileEntity = {
  token: "adv_p1_floor_budget",
  type: "advertiserProfile",
  archetype: "floor-budget-tiny-results",
  displayName: "Copper Kettle Confections",
  brandToken: "b_adv_p1_floor_budget",
  audienceType: "NEW_ONLY",
  globalStatus: "ACTIVE",
  tenureMonths: 21,
  budget: {
    totalBudgetDollars: 200,
    spendingMode: "CONSERVATIVE",
    nextRenewsAtDate: "2026-08-01",
    nextBillsAtDate: "2026-08-04",
  },
  overview: {
    numCustomersAcquired: 0,
    numReorderConversions: 0,
    numTotalConversions: 0,
    totalAdsSalesDollars: 0,
    newCustomerAdsSalesDollars: 0,
    totalAdsSpendDollars: 5,
    newCustomerAdsSpendDollars: 5,
    newCustomerBestEstimateFirstYearRoas: 0,
    combinedFirstYearRoas: 0,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 200,
      maxRecommendedBudgetDollars: 300,
    },
  },
  campaignTokens: ["camp_p1_floor_budget_new"],
  overviewPerformancePeriodTokens: [
    "perf_p1_floor_budget_new_202605",
    "perf_p1_floor_budget_new_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
